/*
 * Copyright 2019 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Catapult REST API Reference
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.7.15
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';
import CommunicationTimestamps from './CommunicationTimestamps';





/**
* The NodeTimeDTO model module.
* @module model/NodeTimeDTO
* @version 0.7.15
*/
export default class NodeTimeDTO {
    /**
    * Constructs a new <code>NodeTimeDTO</code>.
    * @alias module:model/NodeTimeDTO
    * @class
    * @param communicationTimestamps {module:model/CommunicationTimestamps} 
    */

    constructor(communicationTimestamps) {
        

        
        

        this['communicationTimestamps'] = communicationTimestamps;

        
    }

    /**
    * Constructs a <code>NodeTimeDTO</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/NodeTimeDTO} obj Optional instance to populate.
    * @return {module:model/NodeTimeDTO} The populated <code>NodeTimeDTO</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NodeTimeDTO();

            
            
            

            if (data.hasOwnProperty('communicationTimestamps')) {
                obj['communicationTimestamps'] = CommunicationTimestamps.constructFromObject(data['communicationTimestamps']);
            }
        }
        return obj;
    }

    /**
    * @member {module:model/CommunicationTimestamps} communicationTimestamps
    */
    communicationTimestamps = undefined;








}


